import React from "react";
import { Box, Button, TextField, Typography } from "app/material-framework/materialComponents";
import parse from "html-react-parser";
import ChatLoadingWidget from "./ChatLoadingWidget";
import { useTheme } from "@mui/material/styles";

export function UserContextTab({ input, error, summary, loading, onInputChange, onGetSummary, disabled }) {
  const theme = useTheme();
  return (
    <Box sx={{ p: 2, bgcolor: "#F5F5F5", borderBottom: "1px solid #D9D9D9", overflow: "auto" }}>
      <Typography> Enter Publication ID or URL </Typography>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="Enter Publication ID or URLs (seperated by commas)"
          value={input}
          onChange={onInputChange}
          error={!!error}
          helperText={error || ""}
          InputProps={{
            style: {
              backgroundColor: "#FFFFFF",
              color: "#000000E0",
              borderRadius: 16
            },
            inputProps: {
              style: {
                fontSize: "12px"
              }
            }
          }}
        />
        <Button
          variant="contained"
          sx={{
            ml: 1,
            bgcolor: theme.palette.primary.main,
            color: "#fff",
            borderRadius: 2,
            textTransform: "none"
          }}
          onClick={onGetSummary}
          disabled={disabled || !!error || !input.trim() || loading}
        >
          Get Summary
        </Button>
      </Box>
      {loading && <ChatLoadingWidget />}
      {summary && !loading && (
        <Box
          sx={{
            mt: 2,
            p: 2,
            bgcolor: "#EFEFEF",
            borderRadius: 2,
            maxHeight: "70vh",
            overflowY: "auto"
          }}
        >
          {parse(summary)}
        </Box>
      )}
    </Box>
  );
}
